import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'mh-idle-notice',
  standalone: false,
  templateUrl: './idle-notice.component.html',
  host: { class: 'tw-block tw-w-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdleNoticeComponent {
  readonly secondsLeft = input<number>(0);
  readonly stay = output<void>();
  readonly logoutNow = output<void>();
}
